// Pure seams for the party detail page's density pass.
//
// The section-analysis card collapsed into chips: the chip must carry the
// STATE (a rate outside its band, a section other than the expected one) —
// only the explanation table may hide behind the popover.
import type { SectionCut, TxnMatch } from './types'

export interface SectionChipView {
  label: string
  color: 'green' | 'orange' | 'red' | 'gray'
}

export function sectionChip(s: SectionCut): SectionChipView {
  const rate = s.observed_pct != null ? `${s.observed_pct}%` : '—'
  if (s.section_flag && s.section_flag.startsWith('DIFFERENT')) {
    return { label: `${s.section} · ${rate} · ${s.section_flag}`, color: 'red' }
  }
  if (s.rate_flag === 'OUTSIDE BAND') {
    return { label: `${s.section} · ${rate} · OUTSIDE BAND`, color: 'orange' }
  }
  if (s.rate_flag === 'ok') {
    return { label: `${s.section} · ${rate} · OK`, color: 'green' }
  }
  return { label: `${s.section} · ${rate}`, color: 'gray' }
}

export interface MatchGroupView {
  id: number
  /** the group's match_type, from its first row */
  type: string
  s26: TxnMatch[]
  led: TxnMatch[]
  /** exactly one row on each side — renderable as a single flat table row */
  simple: boolean
}

export function splitGroups(matches: TxnMatch[]): MatchGroupView[] {
  const byId = new Map<number, TxnMatch[]>()
  for (const m of matches) {
    const g = byId.get(m.group) ?? []
    g.push(m)
    byId.set(m.group, g)
  }
  return [...byId.keys()]
    .sort((a, b) => a - b)
    .map((id) => {
      const rows = byId.get(id) ?? []
      const s26 = rows.filter((r) => r.side === '26AS')
      const led = rows.filter((r) => r.side !== '26AS')
      return {
        id,
        type: rows[0]?.match_type ?? 'match',
        s26,
        led,
        simple: s26.length === 1 && led.length === 1,
      }
    })
}
